"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trafficTopicView = exports.trafficTopicClick = exports.trafficTopicCategoryClick = exports.trafficSearchSuggestionsView = exports.trafficSearchSuggestionClick = exports.trafficSearchSubmit = exports.trafficSearchResultsView = exports.trafficSearchResultClick = exports.trafficNavigationClick = exports.trafficBreadcrumbClick = exports.trafficFooterClick = exports.trafficArticleView = exports.trafficArticleClick = exports.searchSuggestionsSetIndex = exports.searchSuggestionsGet = exports.searchSuggestionsClear = exports.searchResultsGet = exports.searchResultsClear = exports.topicsGet = exports.topicsClear = exports.articleGet = exports.articleClear = exports.appTopicIdSet = exports.appTopicIdClear = exports.appQuerySet = exports.appMarketSet = exports.appLoadingSet = exports.appHistoryIndexSet = exports.appHistoryEntriesSet = exports.appEnvSet = exports.appClear = void 0;

var _constants = require("../constants");

var _http = require("../http");

var _traffic = require("../traffic");

var _utilities = require("../utilities");

var _types = require("./types");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var appClear = function appClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch({
                  type: _types.APP_CLEAR
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.appClear = appClear;

var appEnvSet = function appEnvSet(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (value !== _constants.ENV_STRINGS.prod && value !== _constants.ENV_STRINGS.test) value = _constants.ENV_STRINGS.dev;
                _context2.next = 3;
                return dispatch({
                  payload: value,
                  type: _types.APP_ENV_SET
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.appEnvSet = appEnvSet;

var appHistoryEntriesSet = function appHistoryEntriesSet(entries) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch({
                  payload: entries,
                  type: _types.APP_HISTORY_ENTRIES_SET
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.appHistoryEntriesSet = appHistoryEntriesSet;

var appHistoryIndexSet = function appHistoryIndexSet(index) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(dispatch) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dispatch({
                  payload: index,
                  type: _types.APP_HISTORY_INDEX_SET
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

exports.appHistoryIndexSet = appHistoryIndexSet;

var appLoadingSet = function appLoadingSet(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(dispatch) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return dispatch({
                  payload: value,
                  type: _types.APP_LOADING_SET
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};

exports.appLoadingSet = appLoadingSet;

var appMarketSet = function appMarketSet() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.MARKET_EN_US;
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(dispatch) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return dispatch({
                  payload: value,
                  type: _types.APP_MARKET_SET
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

exports.appMarketSet = appMarketSet;

var appQuerySet = function appQuerySet(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(dispatch) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return dispatch({
                  payload: value,
                  type: _types.APP_QUERY_SET
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};

exports.appQuerySet = appQuerySet;

var appTopicIdClear = function appTopicIdClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(dispatch) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return dispatch({
                  type: _types.APP_TOPIC_ID_CLEAR
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x8) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};

exports.appTopicIdClear = appTopicIdClear;

var appTopicIdSet = function appTopicIdSet(topicId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee9(dispatch) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return dispatch({
                  payload: topicId,
                  type: _types.APP_TOPIC_ID_SET
                });

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x9) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
};

exports.appTopicIdSet = appTopicIdSet;

var articleClear = function articleClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee10(dispatch) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return dispatch({
                  type: _types.ARTICLE_CLEAR
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x10) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
};

exports.articleClear = articleClear;

var articleGet = function articleGet(articleId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee11(dispatch, getState) {
        var _getState, _getState$app, env, market, _ref12, article, error;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _getState = getState(), _getState$app = _getState.app, env = _getState$app.env, market = _getState$app.market;
                _context11.next = 3;
                return (0, _http.request)({
                  market: market,
                  method: 'get',
                  url: "".concat((0, _utilities.getApiEndpoint)(env), "/helpArticle/").concat(articleId)
                });

              case 3:
                _ref12 = _context11.sent;
                article = _ref12.data;
                error = _ref12.error;

                if (!error) {
                  _context11.next = 10;
                  break;
                }

                _context11.next = 9;
                return dispatch({
                  payload: error,
                  type: _types.APP_ERROR_SET
                });

              case 9:
                return _context11.abrupt("return", _context11.sent);

              case 10:
                _context11.next = 12;
                return dispatch({
                  payload: article,
                  type: _types.ARTICLE_SET
                });

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x11, _x12) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
};

exports.articleGet = articleGet;

var topicsClear = function topicsClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref13 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee12(dispatch) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return dispatch({
                  type: _types.TOPICS_CLEAR
                });

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x13) {
        return _ref13.apply(this, arguments);
      };
    }()
  );
};

exports.topicsClear = topicsClear;

var topicsGet = function topicsGet() {
  return (
    /*#__PURE__*/
    function () {
      var _ref14 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee13(dispatch, getState) {
        var _getState2, _getState2$app, env, market, _ref15, topics, error;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _getState2 = getState(), _getState2$app = _getState2.app, env = _getState2$app.env, market = _getState2$app.market;
                _context13.next = 3;
                return (0, _http.request)({
                  market: market,
                  method: 'get',
                  url: "".concat((0, _utilities.getApiEndpoint)(env), "/helpTopics")
                });

              case 3:
                _ref15 = _context13.sent;
                topics = _ref15.data;
                error = _ref15.error;

                if (!error) {
                  _context13.next = 10;
                  break;
                }

                _context13.next = 9;
                return dispatch({
                  payload: error,
                  type: _types.APP_ERROR_SET
                });

              case 9:
                return _context13.abrupt("return", _context13.sent);

              case 10:
                _context13.next = 12;
                return dispatch({
                  payload: topics,
                  type: _types.TOPICS_SET
                });

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x14, _x15) {
        return _ref14.apply(this, arguments);
      };
    }()
  );
};

exports.topicsGet = topicsGet;

var callSearchApi =
/*#__PURE__*/
function () {
  var _ref17 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee14(_ref16) {
    var query, searchPage, size, state, _state$app, env, market, topicId;

    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            query = _ref16.query, searchPage = _ref16.searchPage, size = _ref16.size, state = _ref16.state;
            _state$app = state.app, env = _state$app.env, market = _state$app.market, topicId = _state$app.topicId;
            _context14.next = 4;
            return (0, _http.request)({
              market: market,
              method: 'get',
              url: "".concat((0, _utilities.getApiEndpoint)(env), "/helpSearch"),
              params: {
                q: query,
                pg: searchPage,
                topicId: topicId || null,
                size: size
              }
            });

          case 4:
            return _context14.abrupt("return", _context14.sent);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function callSearchApi(_x16) {
    return _ref17.apply(this, arguments);
  };
}();

var searchResultsClear = function searchResultsClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref18 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee15(dispatch) {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return dispatch({
                  type: _types.SEARCH_RESULTS_CLEAR
                });

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x17) {
        return _ref18.apply(this, arguments);
      };
    }()
  );
};

exports.searchResultsClear = searchResultsClear;

var searchResultsGet = function searchResultsGet(_ref19) {
  var query = _ref19.query,
      _ref19$searchPage = _ref19.searchPage,
      searchPage = _ref19$searchPage === void 0 ? '1' : _ref19$searchPage,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? _constants.SEARCH_RESULTS_COUNT : _ref19$size;
  return (
    /*#__PURE__*/
    function () {
      var _ref20 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee16(dispatch, getState) {
        var _ref21, searchResults, errorFirstCall, _ref22, searchResultsSecondCall, errorSecondCall;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return callSearchApi({
                  query: query,
                  searchPage: searchPage,
                  size: size,
                  state: getState()
                });

              case 2:
                _ref21 = _context16.sent;
                searchResults = _ref21.data;
                errorFirstCall = _ref21.error;

                if (!errorFirstCall) {
                  _context16.next = 9;
                  break;
                }

                _context16.next = 8;
                return dispatch({
                  payload: errorFirstCall,
                  type: _types.APP_ERROR_SET
                });

              case 8:
                return _context16.abrupt("return", _context16.sent);

              case 9:
                if (!(searchResults && searchResults.suggest && searchResults.suggest.text)) {
                  _context16.next = 21;
                  break;
                }

                _context16.next = 12;
                return callSearchApi({
                  query: searchResults.suggest.text,
                  searchPage: searchPage,
                  size: size,
                  state: getState()
                });

              case 12:
                _ref22 = _context16.sent;
                searchResultsSecondCall = _ref22.data;
                errorSecondCall = _ref22.error;

                if (!errorSecondCall) {
                  _context16.next = 19;
                  break;
                }

                _context16.next = 18;
                return dispatch({
                  payload: errorSecondCall,
                  type: _types.APP_ERROR_SET
                });

              case 18:
                return _context16.abrupt("return", _context16.sent);

              case 19:
                searchResults.results = searchResultsSecondCall.results;
                searchResults.total = searchResultsSecondCall.total;

              case 21:
                _context16.next = 23;
                return dispatch({
                  payload: {
                    query: query,
                    searchResults: searchResults,
                    searchPage: searchPage
                  },
                  type: _types.SEARCH_RESULTS_SET
                });

              case 23:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x18, _x19) {
        return _ref20.apply(this, arguments);
      };
    }()
  );
};

exports.searchResultsGet = searchResultsGet;

var searchSuggestionsClear = function searchSuggestionsClear() {
  return (
    /*#__PURE__*/
    function () {
      var _ref23 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee17(dispatch) {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return dispatch({
                  type: _types.SEARCH_SUGGESTIONS_CLEAR
                });

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x20) {
        return _ref23.apply(this, arguments);
      };
    }()
  );
};

exports.searchSuggestionsClear = searchSuggestionsClear;

var searchSuggestionsGet = function searchSuggestionsGet(query) {
  return (
    /*#__PURE__*/
    function () {
      var _ref24 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee18(dispatch, getState) {
        var _getState3, _getState3$app, env, market, _ref25, searchSuggestions, error;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _getState3 = getState(), _getState3$app = _getState3.app, env = _getState3$app.env, market = _getState3$app.market;
                _context18.next = 3;
                return (0, _http.request)({
                  market: market,
                  method: 'get',
                  url: "".concat((0, _utilities.getApiEndpoint)(env), "/helpSuggest"),
                  params: {
                    q: query
                  }
                });

              case 3:
                _ref25 = _context18.sent;
                searchSuggestions = _ref25.data;
                error = _ref25.error;

                if (!error) {
                  _context18.next = 10;
                  break;
                }

                _context18.next = 9;
                return dispatch({
                  payload: error,
                  type: _types.APP_ERROR_SET
                });

              case 9:
                return _context18.abrupt("return", _context18.sent);

              case 10:
                _context18.next = 12;
                return dispatch({
                  payload: searchSuggestions,
                  type: _types.SEARCH_SUGGESTIONS_SET
                });

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x21, _x22) {
        return _ref24.apply(this, arguments);
      };
    }()
  );
};

exports.searchSuggestionsGet = searchSuggestionsGet;

var searchSuggestionsSetIndex = function searchSuggestionsSetIndex(index) {
  return (
    /*#__PURE__*/
    function () {
      var _ref26 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee19(dispatch) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return dispatch({
                  type: _types.SEARCH_SUGGESTIONS_SET_ACTIVE,
                  payload: index
                });

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x23) {
        return _ref26.apply(this, arguments);
      };
    }()
  );
};

exports.searchSuggestionsSetIndex = searchSuggestionsSetIndex;

var trafficArticleClick = function trafficArticleClick(_ref27) {
  var articleId = _ref27.articleId,
      from = _ref27.from;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee20() {
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_ARTICLE_CLICK,
                properties: {
                  articleId: String(articleId),
                  from: from
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }))
  );
};

exports.trafficArticleClick = trafficArticleClick;

var trafficArticleView = function trafficArticleView(_ref29) {
  var articleId = _ref29.articleId;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee21() {
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_ARTICLE_VIEW,
                properties: {
                  articleId: String(articleId)
                },
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }))
  );
};

exports.trafficArticleView = trafficArticleView;

var trafficFooterClick = function trafficFooterClick(_ref31) {
  var name = _ref31.name;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee22() {
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_FOOTER_CLICK,
                properties: {
                  name: name
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }))
  );
};

exports.trafficFooterClick = trafficFooterClick;

var trafficBreadcrumbClick = function trafficBreadcrumbClick(_ref33) {
  var type = _ref33.type;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee23() {
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_BREADCRUMB_CLICK,
                properties: {
                  type: type
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }))
  );
};

exports.trafficBreadcrumbClick = trafficBreadcrumbClick;

var trafficNavigationClick = function trafficNavigationClick(_ref35) {
  var type = _ref35.type;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee24() {
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_NAVIGATION_CLICK,
                properties: {
                  type: type
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }))
  );
};

exports.trafficNavigationClick = trafficNavigationClick;

var trafficSearchResultClick = function trafficSearchResultClick(_ref37) {
  var articleId = _ref37.articleId,
      query = _ref37.query;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee25() {
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_SEARCH_RESULT_CLICK,
                properties: {
                  articleId: String(articleId),
                  query: query
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }))
  );
};

exports.trafficSearchResultClick = trafficSearchResultClick;

var trafficSearchResultsView = function trafficSearchResultsView(_ref39) {
  var count = _ref39.count,
      page = _ref39.page,
      query = _ref39.query,
      results = _ref39.results;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee26() {
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_SEARCH_RESULTS_VIEW,
                properties: {
                  count: count,
                  page: Number(page),
                  query: query,
                  results: results
                },
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }))
  );
};

exports.trafficSearchResultsView = trafficSearchResultsView;

var trafficSearchSubmit = function trafficSearchSubmit(_ref41) {
  var query = _ref41.query;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee27() {
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_SEARCH_SUBMIT,
                properties: {
                  query: query
                },
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }))
  );
};

exports.trafficSearchSubmit = trafficSearchSubmit;

var trafficSearchSuggestionClick = function trafficSearchSuggestionClick(_ref43) {
  var query = _ref43.query,
      suggestion = _ref43.suggestion;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee28() {
      return regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_SEARCH_SUGGESTION_CLICK,
                properties: {
                  query: query,
                  suggestion: suggestion
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }))
  );
};

exports.trafficSearchSuggestionClick = trafficSearchSuggestionClick;

var trafficSearchSuggestionsView = function trafficSearchSuggestionsView(_ref45) {
  var count = _ref45.count,
      query = _ref45.query,
      suggestions = _ref45.suggestions;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee29() {
      return regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_SEARCH_SUGGESTIONS_VIEW,
                properties: {
                  count: count,
                  query: query,
                  suggestions: suggestions
                },
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }))
  );
};

exports.trafficSearchSuggestionsView = trafficSearchSuggestionsView;

var trafficTopicCategoryClick = function trafficTopicCategoryClick(_ref47) {
  var name = _ref47.name,
      topicId = _ref47.topicId;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee30() {
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_TOPIC_CATEGORY_CLICK,
                properties: {
                  name: name,
                  topicId: String(topicId)
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }))
  );
};

exports.trafficTopicCategoryClick = trafficTopicCategoryClick;

var trafficTopicClick = function trafficTopicClick(_ref49) {
  var topicId = _ref49.topicId;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee31() {
      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_TOPIC_CLICK,
                properties: {
                  topicId: String(topicId)
                },
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }))
  );
};

exports.trafficTopicClick = trafficTopicClick;

var trafficTopicView = function trafficTopicView(_ref51) {
  var topicId = _ref51.topicId;
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee32() {
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_TOPIC_VIEW,
                properties: {
                  topicId: String(topicId)
                },
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }))
  );
};

exports.trafficTopicView = trafficTopicView;